import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * <ControlPolicyStatusToken /> — inline status indicator for the 9-value
 * ControlPolicyStatus enum (packages/core). Accepts `status` as a plain
 * string to avoid a cross-package type dependency.
 *
 * Renders a colored dot + label, matching the StatusBadge pattern.
 */
const STATUS_META = {
    no_spec: { label: 'No spec', color: 'var(--text-dim)' },
    baseline_available: { label: 'Baseline available', color: 'var(--accent)' },
    spec_pending_review: { label: 'Under review', color: 'var(--warning)' },
    spec_active: { label: 'Spec active', color: 'var(--accent)' },
    evidence_present: { label: 'Evidence present', color: 'var(--accent)' },
    evaluated_pass: { label: 'Passing', color: 'var(--success, var(--accent))' },
    evaluated_fail: { label: 'Failing', color: 'var(--error, var(--warning))' },
    stale: { label: 'Stale', color: 'var(--warning)' },
    not_applicable: { label: 'N/A', color: 'var(--text-dim)' },
};
export function ControlPolicyStatusToken({ status, className, }) {
    const m = STATUS_META[status] ?? { label: status, color: 'var(--text-dim)' };
    return (_jsxs("span", { className: className, "data-policy-status": status, style: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: '6px',
            fontFamily: 'var(--font-ui)',
            fontSize: 'var(--font-size-3xs)',
            fontWeight: 500,
            whiteSpace: 'nowrap',
            color: m.color,
        }, "aria-label": m.label, children: [_jsx("span", { "aria-hidden": "true", style: {
                    display: 'inline-block',
                    width: '6px',
                    height: '6px',
                    borderRadius: '50%',
                    backgroundColor: m.color,
                    flexShrink: 0,
                } }), m.label] }));
}
//# sourceMappingURL=ControlPolicyStatusToken.js.map